import { css } from '@emotion/core';
import { useIntl } from 'gatsby-plugin-intl';
import React from 'react';
import { Desktop, Tablet } from '../../constants/responsive';
import { CloseOutlined } from '@ant-design/icons';

// 免责声明
const ProductDetailsDisclaimer = ({
  show = false,
  onClose = () => {},
  pid,
}) => {
  const intl = useIntl();

  // SG的佣金率为0.2%
  // SGM为0.08%
  // SGU为0.5%
  // 其他的主题组合的佣金率为0.3%
  var rate = '0.3%';
  if (pid === 32) {
    rate = '0.2%';
  } else if (pid === 56) {
    rate = '0.5%';
  } else if (pid === 33) {
    rate = '0.08%';
  }
  return (
    <>
      {show && (
        <div
          css={css`
            position: fixed;
            z-index: 9999;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
          `}
        >
          <div
            css={css`
              border-radius: 17px;
              background: white;
              display: flex;
              flex-direction: column;
              max-width: 600px;
              font-size: 12px;
              @media (max-width: 400px) {
                font-size: 10px;
                line-height: 14px;
              }
              line-height: 16px;
              position: relative;
              ${Tablet} {
                padding: 30px 30px 35px;
                font-size: 16px;
                line-height: 1.25;
              }
              ${Desktop} {
                padding: 30px 30px 35px;
                font-size: 16px;
                line-height: 1.25;
              }
            `}
          >
            <div
              css={css`
                display: flex;
                justify-content: flex-end;
              `}
            >
              <CloseOutlined
                css={css`
                  font-size: 20px;
                  color: #707070;
                `}
                onClick={() => {
                  onClose();
                }}
              />
            </div>
            <div
              css={css`
                text-align: left;
              `}
            >
              <b>
                {
                  {
                    en: 'Disclaimer:',
                    'zh-cn': '免责声明：',
                    'zh-hk': '免責聲明：',
                  }[intl.locale]
                }
              </b>
              <br />
              {
                {
                  en: (
                    <div>
                      The data are back-tested performance with {rate} of
                      transaction cost considered. Investment involves risks.
                      Past performance is not indicative of future returns. Any
                      materials, information or reports published, distributed
                      or otherwise made available on the AQUMON website/app is
                      published for information purposes only and is subject to
                      change at any time without notice. They have no regard to
                      the specific investment objectives, financial situation or
                      particular needs of any specific recipient and should not
                      be construed as a solicitation, recommendation or offer,
                      to buy or sell any securities, investment or other
                      financial instruments, to effect any transactions or to
                      conclude any legal act of any kind whatsoever. Unless
                      specifically stated otherwise, all price information is
                      indicative only.
                    </div>
                  ),
                  'zh-cn': (
                    <div>
                      有关数据为投资组合的回测表现，已包含{rate}
                      交易费用。投资有风险，过往收益不代表未来。
                      AQUMON网站/应用程序上发布列明的资讯（包括但不限于文字、图形、数据、模型）只供说明用途，并可随时更改，恕不另行通知。本资讯未考虑任何特定投资者的投资目标、财务状况或特定需求，也不构成招揽、销售、建议或要约任何人使用本资讯所示之投资服务，AQUMON及其发行公司对任何依赖本资讯而引致的损失概不负责。除非另有特别说明，所有价格信息仅供参考。
                    </div>
                  ),
                  'zh-hk': (
                    <div>
                      有關數據為投資組合的回測表現，已包含{rate}
                      交易費用。投資有風險，過往收益不代表未來。
                      AQUMON網站/應用程序上發布列明的資訊（包括但不限於文字、圖形、數據、模型）只供說明用途，並可隨時更改，恕不另行通知。本資訊未考慮任何特定投資者的投資目標、財務狀況或特定需求，也不構成招攬、銷售、建議或要約任何人使用本資訊所示之投資服務，AQUMON及其發行公司對任何依賴本資訊而引致的損失概不負責。除非另有特別說明，所有價格信息僅供參考。
                    </div>
                  ),
                }[intl.locale]
              }
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDetailsDisclaimer;
